var urlParams;

;(function($, undefined){
    'use strict';

var rnn = window.rnn;

    function sidebarNavFunctions(){
        var $rangesModule = $('.facet-module.ranges');
        var $freeformModule = $('.facet-module.freeform');
        var $checkboxModule = $('.facet-module.checkbox-module');

        //Various facet functions on sidebar nav.
        $rangesModule.find('button').click(function(event) {
            event.preventDefault();
            updateRange($(this));
        });

        $freeformModule.find('button').click(function(event) {
            event.preventDefault();
            updateFreeform($(this));
        });

        $rangesModule.find('input:last').keypress(function(event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13') {
                updateRange($(this).closest('.facet-module').find('.add-button'));
            }
        });

        $freeformModule.find('input').keydown(function(event) {
            $freeformModule.find('.facet-button-show').removeClass('hide');
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                updateFreeform($freeformModule.find('.facet-button-show'), true);
            }
        });

        $('select#suburbs-facet').change(function(){
            if($(this).val() === 'All Suburbs'){
                // reset
                resetSuburbFacet();
            }else{
                updateURLParams('suburb', $(this).val());
            }
        });

        $('.facet-suburb-remove').click(function() {
            resetSuburbFacet();
        });

        $checkboxModule.find('label').click(function() {
            loadCheckbox(this);
        });

        $checkboxModule.find('.remove-button').click(function() {
            resetCheckboxes(this);
        });
    }

    /*
        We need to simulate a href click once you click on a checkbox.
    */
    function loadCheckbox(label){
        // we need to simulate a href click.
        var newURL = $(label).find('input').data('link');
        window.location.href = newURL;
    }

    /*
        Reset the checkboxes once you hit the big bad clear button.
    */
    function resetCheckboxes(button){
        var data = $(button).data('clear');
        var collectedData = data.split(',');
        var currURL = window.location.href;

        for(var i = 0; i < collectedData.length; i++){
            var currentItem = collectedData[i];

            currURL = currURL.replace(currentItem + '/', '');
        }

        window.location.href = currURL;
    }

    /*
        Reset the suburb facets select box.
    */
    function resetSuburbFacet(){
        var key = 'suburb';
        var url = window.location.href.split('?')[0];

        delete urlParams[key];

        var query_string = $.param(urlParams);
        window.location.href = query_string ? url + '?' + query_string : url;
    }

    /*
        standard method on updating the url params with the key/value.
    */
    function updateURLParams(key, value) {
        var url = window.location.href.split('?')[0];

        delete urlParams['page']; // reset the conditions so remove page.
        urlParams[key] = value;

        window.location.href = url + '?' + $.param(urlParams);
    }

    /*
        essentially just appending the error text to the validation field
        of that module.
    */
    function genValidateError($module, text){
        $module.find('.validation-text')[0].innerHTML += text;

        $module.find('.add-button').toggleClass('hide');
        $module.find('.facet-button-error').toggleClass('hide');
    }

    /*
        clearing the facet.
    */
    function clearFacet($module){
        var key = $module.attr('id').split('-facet')[0];
        var url = window.location.href.split('?')[0];

        delete urlParams[key];

        var query_string = $.param(urlParams);
        window.location.href = query_string ? url + '?' + query_string : url;
    }

    /*
        validation for freeform widget.
    */
    function validateFreeform($module, $input){
        var vali = rnn.modules.validator.validate($input.val(), 'basic');

        if (vali.canReturn === true) {
            if($module.find('.validation-text').html().length > 0){
                $module.find('.validation-text').hide();
            }
            updateURLParams($input.attr('name'), $input.val());
        }else{
            if($module.find('.validation-text').html().length === 0){
                if(vali.errorText === "Please enter a value.") {
                    clearFacet($module);
                } else {
                    genValidateError($module, vali.errorText);
                }
            }
        }
    }

    /*
        updating the freeform field with 'basic' validation. only want to check
        if it exists.

        NOTE: this method is called even on clear, so make sure no validation is
        called then.
    */
    function updateFreeform($freeformButton, enterPressed) {
        var $module = $freeformButton.closest('.facet-module');
        var $input = $module.find('input');

        enterPressed = enterPressed || false;

        if($freeformButton.hasClass('remove-button') && !enterPressed){
            clearFacet($module);
        }else{
            validateFreeform($module, $input);
        }
    }

    /*
        generating the ranges in order to validate.
        our ranges are a bit fancy in that you can only enter one (in either field)
        for it to work correctly. so we need to check if either exist, and stick them
        in the array. if none exist, push them both in the array. it won't validate.
    */
    function genRanges($start, $end){
        var array = [];

        if($start.val().length > 0 || $end.val().length > 0){
            if($start.val().length > 0){
                array.push($start.val());
            }
            if($end.val().length > 0){
                array.push($end.val());
            }
        }else{
            array = [$start, $end];
        }

        return array;
    }

    function genMaxValueRanges($start, $end) {
        var array = [];

        if($end.val().length > 0){
            array.push($end.val());
        }

        if($end.val().length === 0 && $start.val().length > 0){
            array.push($start.val());
        }

        if ($end.is('[max_value]')) {
            if ($end.attr('max_value').length > 0) {
                array.push($end.attr('max_value'));
            }
        }

        return array;
    }

    /*
        updating any range related facet. this will also use the new validator module to check
        if it's numeric or not.
    */
    function updateRange($rangeButton, redirect) {
        redirect = redirect !== undefined ? redirect : true;
        var $module = $rangeButton.closest('.facet-module');
        var $previousInputs = $module.find('input');
        var $start = $previousInputs.eq(0);
        var $end = $previousInputs.eq(1);
        var ranges = genRanges($start, $end);
        var maxValueRanges = genMaxValueRanges($start, $end);
        var $startLength = $start.length;
        var $endLength = $end.length;
        var vali = rnn.modules.validator.validate(ranges, 'numericOrder');
        var checkValidation = $rangeButton.hasClass('.facet-button-remove') ? false : true;

        if($rangeButton.hasClass('remove-button')){
            clearFacet($module);
        }else{
            if (vali.canReturn === true) {
                vali = rnn.modules.validator.validate(maxValueRanges, 'maxValue');

                if($module.find('.validation-text').html().length > 0){
                    $module.find('.validation-text').hide();
                }
                if(redirect === true) {
                    updateURLParams($start.attr('name'), $start.val() + '-' + $end.val());
                }
            }else{
                // load the validate error text.
                if($module.find('.validation-text').html().length === 0 && checkValidation === true){
                    genValidateError($module, vali.errorText);
                }
            }
        }
    }

    /*
        reset input fields if they are clicked on from a state of validation or
        completeness
    */
    function resetInputs(inputField){
        var $module = $(inputField).closest('.facet-module');

        // get the current state.
        var isValidationState, isCompleteState, $activeButton;

        $activeButton = $module.find('button:not(.hide)');

        if($activeButton.hasClass('remove-button')){
            isCompleteState = true;
        }else if($activeButton.hasClass('facet-button-error')){
            isValidationState = true;
        }

        if(isCompleteState === true){
            $module.find('.remove-button').toggleClass('hide');
            $module.find('.add-button').toggleClass('hide');
        }

        if(isValidationState === true){
            $module.find('.facet-button-error').toggleClass('hide');
            $module.find('.add-button').toggleClass('hide');
            $module.find('.validation-text').html('');
        }
    }

    /*
        the classifieds section has a fair bit of interaction going on. various hover
        effects and the like.
    */
    function uiFunctions(){
        // hover effect for the buttons. need to make a span appear.
        $('.facet-btn .add-button').hover(function() {
            $(this).parent().find('.facet-btn-status .apply').toggleClass('hide');
        });

        $('.facet-module.ranges .remove-button').hover(function() {
            var $closestModule = $(this).closest('.facet-module');

            $closestModule.find('.facet-btn').toggleClass('indented-btn');
            $closestModule.find('.facet-btn-status .clear').toggleClass('hide');
        });

        $('.facet-button-error').hover(function() {
            var $module = $(this).closest('.facet-module');

            $module.find('.facet-btn').toggleClass('indented-btn');
            $module.find('.facet-btn-status .validate').toggleClass('hide');
        });

        /*
            Clicking on the clear button should clear the current input values and
            reset the validation.
        */
        $('.facet-button-error').click(function() {
            // clear all of the current validation stuff
            var $module = $(this).closest('.facet-module');

            $module.find('.facet-button-error').toggleClass('hide');
            $module.find('.add-button').toggleClass('hide');
            $module.find('.validation-text').html('');

            // clear the inputs
            $module.find('input').val('');
        });


        // for a facet_list item select, the borders of the selected_tag need to change colour.
        $('.selected-tag .remove-button, .selected-tag .remove-category').hover(function() {
            $(this).closest('.selected-tag').toggleClass('dark-border');
        });

        /*
            at any point, once you click on an input field, any existing clear or
            validation needs to wipe and reset. that way, you can submit again easily.
        */
        $('.facet-module input[type="text"]').focus(function() {
            resetInputs(this);
        });

        // show the clear button for that module if there are any current checkboxes selected.
        $('.facet-module.checkbox-module').each(function(){
            var $this = $(this);
            var checkedLength = $this.find('input:checked').length;

            if(checkedLength > 0){
                $this.closest('.facet-module')
                    .find('.facet-btn .remove-button')
                    .toggleClass('hide');
            }
        });

        /*
            we want to add some fanciness for populated range fields. if they click to modify the
            input field but don't do anything, we need to reset the field to how they are in the URL.
        */

        $('.facet-module.ranges').each(function(){
            var $module = $(this);
            var facet = $module.attr('id').split('-facet')[0];

            if(urlParams[facet] !== undefined){
                $(document).mouseup(function (e){
                    if(!$module.is(e.target) && $module.has(e.target).length === 0){
                        var $inputFields = $module.find('input');
                        var $firstField = $inputFields.eq(0);
                        var $secondField = $inputFields.eq(1);
                        var isNotValidated = !!$module.find('.validation-text').html().length;

                        // grab the values from the urlParams and just set them in the input fields.
                        $firstField.val(urlParams[facet].split('-')[0]);
                        $secondField.val(urlParams[facet].split('-')[1]);

                        // reset the button to be the clear button, too.
                        if(isNotValidated && $module.find('.remove-button').hasClass('hide')){
                            $module.find('.validation-text').html('');
                            $module.find('.facet-button-error').toggleClass('hide');
                            $module.find('.remove-button').toggleClass('hide');
                        }else{
                            if($module.find('.remove-button').hasClass('hide')){
                                $module.find('.add-button').toggleClass('hide');
                                $module.find('.remove-button').toggleClass('hide');
                            }
                        }
                    }
                });
            }
        });
    }

    function updateInputField(module, key){
        // update the input value

        var $inputFields = $(module).find('input');
        var $firstField = $inputFields.eq(0);
        var $secondField = $inputFields.eq(1);

        $firstField.val(urlParams[key].split('-')[0]);
        $secondField.val(urlParams[key].split('-')[1]);
    }

    /*
        sometimes we load elements or change them through JS, so the initial
        event listener didn't catch it. this adds it dom load if required.
    */
    function addSwitchBorderListener($button){
        $button.hover(function() {
            $(this).closest('.selected-tag').toggleClass('dark-border');
        });
    }

    /*
        if we want to set a label and clear the input field, use this.
    */
    function setLabel(module, value){
        var $module = $(module);

        $module.find('input').val(value);
        $module.find('.facet-button-remove').removeClass('hide');
    }

    /*
        essentially going through what facets we have. if there is a value in the query string
        already set, set this value in the relevent input field.
    */
    function populateExistingFacets(){
        $('div[id$=\'-facet\']').each(function() {
            var key = $(this).attr('id').replace('-facet', '');

            if(urlParams[key] !== undefined){

                if($(this).hasClass('freeform')){
                    // Strip HTML elements
                    setLabel(this, urlParams[key].replace(/<(?:.|\n)*?>/gm, ''));
                }else{
                    updateInputField(this, key);
                    if($(this).hasClass('ranges')){
                        updateRange($(this).find('.facet-btn'), false);
                    }
                }

                // show the hide button
                if(!$(this).find('.validation-text').html().length > 0) {
                    $(this).find('.facet-btn .facet-button-remove')
                        .removeClass('hide');
                }else{
                    $(this).find('.facet-btn .add-button').addClass('hide');
                }

            }else{
                // show the apply button
                $(this).find('.facet-btn .add-button')
                        .removeClass('hide');
            }
        });

        // for the select widget.
        $('.facet-module.select').each(function() {
            // if the select facet module has a data attribute associated to it, set the val to that.
            var $suburb = $(this).data('suburb');

            if($suburb){
                $(this).find('select option:contains("' + $suburb + '")').prop('selected',true);
            }
        });
    }

    // Initialise Classifieds
    function initFacets() {
        populateExistingFacets();
        sidebarNavFunctions();
        uiFunctions();
    }

    rnn.modules.register('facets', {
        init: initFacets
    });

})(jQuery);
